<div class="pagination flex align-items-center">
  <button pButton class="p-button-outlined mr-2" [disabled]="page == 0" (click)="goToPage(page - 1)">Anterior</button>

  @if (minPage > 0) {
    <button
      pButton
      class="p-button-outlined w-3rem min-w-min mr-2 justify-content-center"
      [disabled]="page == 0"
      (click)="goToPage(0)"
      >
      1
    </button>
  }

  @if (minPage > 1) {
    <span class="mr-2 font-medium"> ... </span>
  }

  @for (option of pageNavOptions; track option) {
    <button
      pButton
      class="p-button-outlined w-3rem min-w-min mr-2 justify-content-center"
      [ngClass]="{ active: page == option }"
      [disabled]="page == option"
      (click)="goToPage(option)"
      >
      {{ option + 1 }}
    </button>
  }

  @if (lastOffsetFound && maxPage < lastPage - 1) {
    <span class="mr-2 font-medium"> ... </span>
  }

  @if (lastOffsetFound && maxPage < lastPage) {
    <button
      pButton
      class="p-button-outlined w-3rem min-w-min mr-2 justify-content-center"
      [disabled]="page == lastPage"
      (click)="goToPage(lastPage)"
      >
      {{ lastPage + 1 }}
    </button>
  }

  <button pButton class="p-button-outlined mr-2" [disabled]="page >= maxPage" (click)="goToPage(page + 1)">
    Próximo
  </button>

  <p-floatlabel variant="on">
    <p-select
      size="small"
      [options]="sizeOptions"
      [(ngModel)]="size"
      (onChange)="onSizeChanged()"
    ></p-select>
    <label class="text-sm" for="filterGuiaOperadora">Exibir</label>
  </p-floatlabel>
</div>
